/**
 * Képforrások — egy helyen, hogy a srcset szélességei a generátorral (scripts/generate-responsive-images.mjs)
 * egyezzenek. `public/images/<base>.avif` = 1400 px fallback; `responsive/<base>-<w>.avif` = változatok.
 */
export const IMAGE_WIDTHS = [480, 640, 800, 1200, 1600] as const;
export const HERO_WIDTHS = [480, 640, 800, 1200, 1600, 1920, 2560] as const;

/**
 * Azok a képek, amelyeknek a FORRÁSA kisebb a legnagyobb lépcsőnél. A generátor ilyenkor nem készít
 * nagyobb változatot (nem nagyít fel), tehát a srcset-ből is ki kell hagyni — különben a böngésző
 * nem létező fájlt kérne le. Kulcs = base név, érték = a forrás natív szélessége pixelben.
 */
const NATIVE_WIDTH: Record<string, number> = {
  // Péter 2026-09-22-i jacuzzi-fotói e-mailben érkeztek, 1448 px-re kicsinyítve (eredeti kérve).
  'ahaaziko-jacuzzi-terasz': 1448,
  'ahaaziko-jacuzzi-kert': 1448,
};

export const imageSrc = (base: string) => `/images/${base}.avif`;

export function srcSetFor(base: string, widths: readonly number[] = IMAGE_WIDTHS): string {
  const cap = NATIVE_WIDTH[base];
  const available = cap ? widths.filter((w) => w <= cap) : widths;
  return available.map((w) => `/images/responsive/${base}-${w}.avif ${w}w`).join(', ');
}

/** Full-bleed hero háttér: minden szélesség, `sizes="100vw"`. */
export const heroSrcSet = (base: string) => srcSetFor(base, HERO_WIDTHS);

/** Régi hívók: "/images/<base>.avif" útvonalból base név. */
export const baseOf = (src: string) => src.replace(/^\/images\//, '').replace(/\.avif$/, '');
